import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { DatePicker } from 'antd'
const { RangePicker } = DatePicker

const FilterRangeTime = ({ input: { value, onChange } }) => {

  const handleChange = (date, dateString) => {
    const dates = _.isArray(dateString) && dateString
    onChange(_.isNull(date) ? date : { gte: dates[0], lte: dates[1] })
  }

  return (
    <RangePicker
      showTime
      onChange={handleChange}
      format="YYYY-MM-DD HH:mm:ss"
      value={[
        value && value.gte ? moment(value.gte, 'YYYY-MM-DD HH:mm:ss') : '',
        value && value.lte ? moment(value.lte, 'YYYY-MM-DD HH:mm:ss') : ''
      ]}
    />
  )
}

export default FilterRangeTime
